import React, { useContext, useEffect, useState } from "react";
import { AccountContext } from "../contexts/AccountContext";
import StarRatings from "react-star-ratings";
import DOMPurify from "dompurify";
import { toast } from "react-toastify";
import buildLink from "../urls";
import _axios from "../axios";
import { useNavigate } from "react-router-dom";
import DotsLoader from "./DotsLoader";
import { AiOutlineCheck, AiOutlineLike } from "react-icons/ai";
import { path } from "../urls";
import Cookies from "js-cookie";

function Review({ props }) {
  const [likeCounts, setLikeCounts] = useState({});
  const [selectedReviewImg, setSelectedReviewImg] = useState("");
  const [selectedReviewImgIndex, setSelectedReviewImgIndex] = useState(0);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState([]);
  const [loadingreply, setLoadingreply] = useState(false);
  const [pagereply, setpagereply] = useState(1);
  const [replies, setReplies] = useState([]);
  const navigate = useNavigate();
  const [likedReviews, setLikedReviews] = useState([]);
  const [loadingReplies, setLoadingReplies] = useState({});
  const [alreadyLiked, setAlreadyLiked] = useState([]);
  const [replyTexts, setReplyTexts] = useState({});
  const [likeLoading, setLikeLoading] = useState({
    bool: false,
    id: 0,
  });

  useEffect(() => {
    if (props?.liked_by_customer) {
      setAlreadyLiked((current) => [...current, props?.review_id]);
    }
    setLikeCounts((prevLikeCounts) => ({
      ...prevLikeCounts,
      [props?.review_id]: props?.likes,
    }));
  }, []);

  const handleReplyTextChange = (review_id, text) => {
    setReplyTexts((prev) => ({ ...prev, [review_id]: text }));
  };

  const handleReviewLike = (review_id) => {
    if (stateAccount.loged) {
      setLikeLoading({
        bool: true,
        id: review_id,
      });
      _axios
        .post(buildLink("likeUnlikeReview", undefined, undefined) + review_id)
        .then((response) => {
          // console.log(response.data);
          if (response.data.success && response.data.data.liked) {
            setLikedReviews((current) => [...current, review_id]);
            setAlreadyLiked((current) => [...current, review_id]);
          } else {
            setLikedReviews((current) =>
              current.filter((liked) => {
                return liked !== review_id;
              })
            );
            setAlreadyLiked((current) =>
              current.filter((liked) => {
                return liked !== review_id;
              })
            );
          }
          setLikeCounts((prevLikeCounts) => ({
            ...prevLikeCounts,
            [review_id]: response.data.data.nb_likes,
          }));
          setLikeLoading({
            bool: false,
            id: 0,
          });
        });
    } else {
      navigate(`${path}/login`);
    }
  };

  const handleReplySubmit = async (review_id) => {
    const userId = Cookies.get("user_id");

    if (!userId) {
      console.error("User ID not found in cookies.");
      return;
    }

    const body = {
      review_id: review_id,
      user_id: userId,
      comment: replyTexts[review_id], // Defaults to an empty string if no reply text
    };

    try {
      setLoadingreply(true);
      const response = await _axios.post(
        buildLink(
          "reviewsreply",
          undefined,
          window.innerWidth,
          window.config["site-url"]
        ),
        body
      );
      toast(response.data.message, { type: "success" });
      setLoadingreply(false);

      //window.location.reload();
    } catch (error) {
      console.error("Error submitting reply:", error);

      const errorMessage = error.response
        ? error.response.data.message
        : "An error occurred.";
      toast(errorMessage, { type: "error" });

      setLoadingreply(false);
    }
  };

  async function showMoreReplies(review_id) {
    try {
      setLoadingreply(true); // Set loading state to true
      const url =
        buildLink(
          "reviewsreply",
          undefined,
          window.innerWidth,
          `${window.config["site-url"]}`
        ) + `&review_id=${review_id}&page=${pagereply}`;

      const response = await _axios.get(url);

      if (response && response.data) {
        setpagereply(response.data.data.next_page);
        let reviewreplies = response.data.data.replies;
        setReplies({ review_id: review_id, reviewreplies: reviewreplies });
      }
    } catch (error) {
      console.error("Error submitting reply:", error);

      const errorMessage = error.response
        ? error.response.data.message
        : "An error occurred.";
      toast(errorMessage, { type: "error" });
    } finally {
      setLoadingreply(false);
    }
  }

  function sanitizeHTML(html) {
    if (typeof window !== "undefined") {
      return DOMPurify.sanitize(html);
    } else {
      return html;
    }
  }

  async function handleDeleteReply(replyId) {
    try {
      setLoadingreply(true);

      const url =
        buildLink(
          "reviewsreply",
          undefined,
          window.innerWidth,
          `${window.config["site-url"]}`
        ) + `&review_comment_id=${replyId}`;

      const response = await _axios.delete(url);

      if (response && response.data) {
        toast(response.data.message, { type: "success" });
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting reply:", error);

      const errorMessage = error.response
        ? error.response.data.message
        : "An error occurred.";
      toast(errorMessage, { type: "error" });
    } finally {
      setLoadingreply(false);
    }
  }

  function handleReviewsModal(img, index, review) {
    setSelectedReviewImg(img);
    setSelectedReviewImgIndex(index);
    setShowReviewModal(true);
    setSelectedReview(review);
    const htmlElement = document.querySelector("html");
    const bodyElement = document.querySelector("body");

    // Add a CSS class to remove the overflow-y
    htmlElement.classList.add("popup-open");
    bodyElement.classList.add("popup-open");
  }
  const color = {
    a: "#FFEBCD	",
    b: "#00BFFF",
    c: "#00BFFF",
    d: "#00BFFF",
    e: "#DC143C",
    f: "#bf1b26",
    g: "#008000",
    h: "#008000",
    i: "#008000",
    j: "#008000",
    k: "#008000",
    l: "#008000",
    m: "#008000",
    n: "#008000",
    o: "#F08080	",
    p: "#bf1b26",
    q: "#bf1b26",
    r: "#DC143C",
    t: "#FFD700",
    u: "#bf1b26",
    v: "#bf1b26",
    w: "#bf1b26",
    x: "#bf1b26",
    y: "#00BFFF",
    z: "#00BFFF",
    s: "#DC143C",
  };

  const textColor = {
    a: "#FFEBCD	",
    b: "#00BFFF",
    c: "#00BFFF",
    d: "#00BFFF",
    e: "#DC143C",
    f: "#bf1b26",
    g: "#008000",
    h: "#008000",
    i: "#008000",
    j: "#008000",
    k: "#008000",
    l: "#008000",
    m: "#008000",
    n: "#008000",
    o: "#F08080	",
    p: "#bf1b26",
    q: "#bf1b26",
    r: "#DC143C",
    t: "#FFD700",
    u: "#bf1b26",
    v: "#bf1b26",
    w: "#bf1b26",
    x: "#bf1b26",
    y: "#00BFFF",
    z: "#00BFFF",
    s: "#00BFFF",
  };

  const [stateAccount, dispatchAccount] = useContext(AccountContext);

  return (
    <div
      className="border-b-2 border-dinputBorder pb-4 mt-4 flex flex-col gap-2 bg-white p-4 rounded-md"
      key={props?.review_id}
    >
      {/* User Info & Avatar */}
      <div className="flex items-start gap-3">
        <div
          className="flex items-center justify-center w-14 h-14 min-w-[56px] rounded-full border-2 text-white font-bold text-lg"
          style={{
            backgroundColor:
              color[props.name?.replace(/\s+/g, "").charAt(0)?.toLowerCase()] ||
              "red",
          }}
        >
          {props?.name?.replace(/\s+/g, "").charAt(0).toUpperCase()}
        </div>

        <div className="flex flex-col gap-0.5">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="text-base font-bold">{props?.name}</p>

            {props?.check_purchase && (
              <div className="flex items-center gap-1 text-d12 text-[#3866DF] border-l-2 border-dinputBorder pl-2">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.07262 9.64218L2.67767 7.24723L3.52189 6.403L5.07262 7.94775L9.0183 4.00206L9.86252 4.85227L5.07262 9.64218ZM6.2701 0.661133C2.96506 0.661133 0.282715 3.34348 0.282715 6.64851C0.282715 9.95355 2.96506 12.6359 6.2701 12.6359C9.57513 12.6359 12.2575 9.95355 12.2575 6.64851C12.2575 3.34348 9.57513 0.661133 6.2701 0.661133Z"
                    fill="#3866DF"
                  />
                </svg>
                <p>Verified Purchase</p>
              </div>
            )}
          </div>

          {/* Star Rating */}
          <div className="-mt-1">
            <StarRatings
              starDimension="18px"
              starSpacing="1px"
              starEmptyColor="#e3e3e3"
              starRatedColor="#f5a523"
              rating={parseInt(props?.rating)}
            />
          </div>

          
        </div>
      </div>

      <div className="flex w-full justify-between ">
        {/* Text */}
        <div
          className=" text-d pt-1 w-4/5 text-start"
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(props?.text) }}
        />

        {/* Images */}
        <div className="w-1/5">
          {props?.images?.length > 0 && (
            <div className="flex gap-2 justify-end">
              {props.images.map((img, i) => (
                <div
                  key={i}
                  className="cursor-pointer"
                  onClick={() => handleReviewsModal(img, i, props)}
                >
                  <img
                    src={img}
                    alt="review-img"
                    className="w-14 h-14 sm:w-20 sm:h-20 object-cover rounded-md"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Replies */}
      {props?.review_replies?.length > 0 && (
        <div className="pl-4 mt-2">
          <h3 className="text-sm text-dgrey1 font-semibold mb-1">Replies</h3>
          <ul className="list-disc list-inside space-y-1">
            {props.review_replies.map((reply) => (
              <li
                key={reply.id}
                className="bg-white border-l-4 border-dgrey1 p-2 rounded text-dgrey1 text-sm flex justify-between"
              >
                <span>{reply.comment}</span>
                {stateAccount.admin && (
                  <button
                    onClick={() => handleDeleteReply(reply.id)}
                    className="text-dbase ml-4"
                  >
                    Delete
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Show More Replies */}
      {replies.review_id === props.review_id &&
        replies.reviewreplies?.map((rep) => (
          <li
            key={rep.id}
            className="bg-white border-l-4 ml-4 border-dgrey1 p-2 mt-1 rounded text-dgrey1 text-sm flex justify-between"
          >
            <span>{rep.comment}</span>
            {stateAccount.admin && (
              <button
                onClick={() => handleDeleteReply(rep.id)}
                className="text-dbase ml-4"
              >
                Delete
              </button>
            )}
          </li>
        ))}

      {props?.show_more_replies && (
        <div className="flex justify-center mt-2">
          <button
            onClick={() => showMoreReplies(props?.review_id)}
            className="text-dblue hover:underline flex items-center text-d12"
            disabled={loadingreply}
          >
            {loadingreply ? (
              <div className="w-5 h-5">loading...</div>
            ) : (
              <>
                Show More Replies
                <svg
                  className="h-4 w-4 ml-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06-.02L10 10.67l3.71-3.48a.75.75 0 111.04 1.08l-4.25 4a.75.75 0 01-1.04 0l-4.25-4a.75.75 0 01-.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      )}

      {/* Like Button */}
      <div className="flex items-center justify-between gap-5 my-2">
        {/* Date */}
        <p className="text-base text-gray-400 text-left">
            {props?.date_added?.replaceAll("-", " ")}
        </p>

        <div className="flex gap-2">
          <div
            onClick={() => handleReviewLike(props.review_id)}
            className={`flex items-center gap-1 border w-max px-2 py-1 rounded text-sm cursor-pointer ${
              alreadyLiked.includes(props.review_id)
                ? "border-dblue text-dblue"
                : "border-[#7E859B] text-[#7E859B]"
            }`}
          >
            <AiOutlineLike />
            {likeLoading.bool && likeLoading.id === props.review_id ? (
              <div className="py-1.5 pr-4">loading...</div>
            ) : alreadyLiked.includes(props.review_id) ? (
              <div>{likeCounts[props.review_id]}</div>
            ) : (
              <div
              >
                Helpful
                {likeCounts?.[props.review_id] &&
                likeCounts[props.review_id] !== "0"
                  ? ` (${likeCounts[props.review_id]})`
                  : ""}
              </div>
            )}
          </div>

          {likedReviews?.includes(props.review_id) && (
            <div className="flex items-center gap-1.5">
              <AiOutlineCheck className="text-dgreen text-lg" />
              <p className="text-sm text-gray-500">Thanks for voting!</p>
            </div>
          )}
        </div>
      </div>

      {/* {stateAccount.admin && (
      <div className="flex items-center w-1/2 max-sm:w-full">
        <input
          className="border border-dgrey1 rounded-md px-2 py-1 w-full flex-1"
          type="text"
          value={replyTexts[props?.review_id] || ""}
          onChange={(e) =>
            handleReplyTextChange(
              props?.review_id,
              e.target.value
            )
          }
          placeholder="Enter your reply here"
        />
        <button
          className="rounded-md bg-dblue px-4 py-2 text-white flex items-center justify-center w-1/5 ml-2 flex-shrink-0"
          onClick={() => handleReplySubmit(props?.review_id)}
          disabled={loadingReplies[props?.review_id]}
        >
          {loadingReplies[props?.review_id] ? (
            <DotsLoader />
          ) : (
            <svg
              className="h-5 w-5 transform rotate-45"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          )}
        </button>
      </div>
    )} */}
    </div>
  );
}

export default Review;
